export const shape8 = [
    0, 0, 0, 0, 0,
    0, 0, 1, 1, 0,
    0, 1, 1, 0, 0,
    1, 1, 0, 0, 0,
    0, 0, 0, 0, 0,
]